import axios from "axios";
import { apiPortal } from "../../config";
const point = apiPortal + "/setting";
const Seting = {
    async getSetting() {
        try {
            const data = await axios.get(point, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "application/json",
                },
            });
            return data.data;
        } catch (error) {
            if (errro.response) {
                throw error.response.data.message;
            }
            throw error;
        }
    },
};
export default Seting;
